module.exports = __webpack_public_path__ + "visio.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/visio.png
// module id = 395
// module chunks = 0